"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMixerMapperComp = exports.initMapperLayout = exports.initMapperCollectionComp = exports.initInsetComp = exports.initCreateGroup = void 0;
var _globalStates = require("../../globalstates/globalStates");
var _mappers = require("../../standalone/data/default/mappers");
var _utils = require("../../utils");
var _common = require("../common");
var _display = require("../display");
var _MappingGroups = require("./MappingGroups");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initMapperCollectionComp = exports.initMapperCollectionComp = function initMapperCollectionComp(appInstanceID, initMappers, gpuID, uclientLatency, frameRate) {
  return {
    id: {
      value: (0, _utils.generateUUID)()
    },
    name: "",
    description: "",
    appInstanceID: appInstanceID || {
      value: (0, _utils.generateUUID)(),
      appID: {
        value: (0, _globalStates.getGlobalStates)().appID.value
      }
    },
    mappers: initMappers || [],
    frameRate: frameRate || {
      seconds: 1.0,
      frames: 0
    },
    gpuID: gpuID || _MappingGroups.GPUID_NOT_SET,
    uclientLatency: uclientLatency || 0.5,
    userfulSecurityData: (0, _common.EMPTY_USERFUL_SECURITY_DATA)()
  };
};
var initCreateGroup = exports.initCreateGroup = function initCreateGroup(appInstanceID) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "SOURCE_FOLDER";
  return {
    id: {
      value: (0, _utils.generateUUID)()
    },
    name: "",
    description: "",
    type: type,
    color: "#000000",
    appInstanceID: appInstanceID || {
      value: (0, _utils.generateUUID)(),
      appID: {
        value: (0, _globalStates.getGlobalStates)().appID.value
      }
    },
    comps: [],
    createTime: Date.now(),
    updateTime: Date.now(),
    userfulSecurityData: (0, _common.EMPTY_USERFUL_SECURITY_DATA)(),
    appIDs: {
      appIDs: [],
      valid: true
    },
    tagsSet: {
      tags: [],
      valid: true
    },
    folderPath: {
      elements: [],
      valid: true
    },
    parentGroupID: {
      value: "NOT_SET"
    }
  };
};
var initInsetComp = exports.initInsetComp = function initInsetComp() {
  return {
    id: {
      value: (0, _utils.generateUUID)()
    },
    name: "",
    description: "",
    playList: {
      id: _common.STRINGID_NOT_SET,
      name: "",
      description: "",
      sceneID: _common.STRINGID_NOT_SET,
      createdFrom: _common.STRINGID_NOT_SET,
      behaviour: {
        playTimes: {
          times: -1
        },
        startBehaviour: "AUTO_START"
      },
      items: [_objectSpread({}, _mappers.DEFAULT_INSET_PLAYLIST_ITEM)]
    },
    audioData: [_objectSpread({}, _mappers.DEFAULT_INSET_AUDIO_DATA)],
    videoData: [_objectSpread({}, _mappers.DEFAULT_INSET_VIDEO_DATA)],
    sceneID: _common.STRINGID_NOT_SET
  };
};
var initMixerMapperComp = exports.initMixerMapperComp = function initMixerMapperComp() {
  return {
    id: _common.STRINGID_NOT_SET,
    name: "",
    description: "",
    sceneID: _common.STRINGID_NOT_SET,
    appInstanceID: {
      value: "NOT_SET",
      appID: _common.STRINGID_NOT_SET
    },
    gpuID: {
      videoEngineID: _common.STRINGID_NOT_SET,
      gpuSlotID: _common.STRINGID_NOT_SET
    },
    canvasSize: _display.DEFAULT_RESOLUTION,
    logicalGridData: _MappingGroups.DEFAULT_LOGICAL_GRID_DATA,
    insets: [],
    destinations: [],
    groups: [{
      id: {
        value: "NOT_SET"
      },
      destinations: []
    }],
    streams: [],
    textOverlay: {
      text: "",
      visibility: "INVISIBLE",
      config: {
        colour: "ORANGE",
        font: {
          fontName: "Sans"
        },
        style: {
          styleName: "Bold"
        },
        textSize: 32,
        shadow: true,
        outline: true,
        outlineColour: "BLACK",
        xpos: 0.05,
        ypos: 0.05
      }
    },
    videoQuality: {
      quality: 80
    },
    uclientLatency: 0.2,
    frameRate: {
      frames: 30,
      seconds: 1
    },
    provisioningStrategy: "KEEP_RUNNING",
    origin: {
      id: _common.STRINGID_NOT_SET,
      type: "NONE",
      originApp: {
        value: "NOT_SET",
        appID: _common.STRINGID_NOT_SET
      }
    },
    mixerPlayerActivationStatus: "ACTIVE",
    createdTime: 1727197846.629737,
    updatedTime: 1727197846.728602,
    userfulSecurityData: (0, _common.EMPTY_USERFUL_SECURITY_DATA)(),
    destinationStreamType: "RTSP"
  };
};
var initMapperLayout = exports.initMapperLayout = function initMapperLayout() {
  return {
    id: _common.STRINGID_NOT_SET,
    name: "",
    description: "",
    canvasSize: _display.DEFAULT_RESOLUTION,
    logicalGridData: _MappingGroups.DEFAULT_LOGICAL_GRID_DATA,
    mapperCompType: "MIXER",
    insetCompCreators: [],
    streamCompCreators: [],
    createdFrom: _common.STRINGID_NOT_SET,
    createInstant: 1727197846.629737,
    mapperLayoutType: "USER_CREATED"
  };
};